import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { injectIntl } from 'react-intl-next';
import { ProductStates } from '../../../..';
import { messages } from '../../messages';
import { RECENT_SEARCHES_SECTION_ID } from '../sections/recent-search-section';
var RECENTLY_VIEWED_ITEMS_SHOWN = 5;

/**
 * This transformer assumes that preQueryItems contains recently viewed search
 * results and adds them to the postQueryItems.
 */
var PostQueryRecentlyViewedTransformerWithIntl = function PostQueryRecentlyViewedTransformerWithIntl(_ref) {
  var intl = _ref.intl,
    preQueryItems = _ref.preQueryItems,
    postQueryItems = _ref.postQueryItems,
    productState = _ref.productState,
    children = _ref.children;
  // Create an array of recently viewed sections. These sections exclude recent
  // searches and have a combined result limit of 10.
  var recentlyViewedCount = 0;
  var recentlyViewedSections = preQueryItems.sections.filter(function (section) {
    return section.id !== RECENT_SEARCHES_SECTION_ID;
  }).filter(function (section) {
    return section.searchResults.length > 0;
  }).map(function (section, i) {
    var newSection = _objectSpread(_objectSpread({}, section), {}, {
      resultLimit: Math.min(section.searchResults.length, RECENTLY_VIEWED_ITEMS_SHOWN - recentlyViewedCount),
      title: i === 0 ? intl.formatMessage(messages.quick_find_recently_viewed) : ''
    });
    recentlyViewedCount = Math.min(recentlyViewedCount + section.searchResults.length, RECENTLY_VIEWED_ITEMS_SHOWN);
    return newSection;
  });

  // Add recent searches to the end of postQueryItems after post query returns
  var recentSearchesSection = preQueryItems.sections.find(function (section) {
    return section.id === RECENT_SEARCHES_SECTION_ID;
  });
  var postQueryItemsSectionsWithRecentSearches = recentSearchesSection && productState === ProductStates.PostQuerySuccess ? [].concat(_toConsumableArray(postQueryItems.sections), [recentSearchesSection]) : _toConsumableArray(postQueryItems.sections);

  // Create the new postQueryItems object
  var postQueryItemsWithRecentlyViewed = {
    size: [].concat(_toConsumableArray(recentlyViewedSections), _toConsumableArray(postQueryItems.sections)).map(function (section) {
      return section.searchResults.length;
    }).reduce(function (a, b) {
      return a + b;
    }, 0),
    sections: [].concat(_toConsumableArray(recentlyViewedSections), _toConsumableArray(postQueryItemsSectionsWithRecentSearches))
  };
  return children({
    preQueryItems: preQueryItems,
    postQueryItems: postQueryItemsWithRecentlyViewed,
    productState: productState
  });
};
export var PostQueryRecentlyViewedTransformer = injectIntl(PostQueryRecentlyViewedTransformerWithIntl);